import { $applyNodeReplacement, DecoratorNode, DOMConversionMap, DOMExportOutput, NodeKey, SerializedLexicalNode, Spread } from 'lexical';
import { Video, VideoProperties } from '../components/Video';

export type SerializedVideoProperties =
{
    properties?: VideoProperties
}

export type SerializedVideoNode = Spread<SerializedVideoProperties, SerializedLexicalNode>;

export function $createVideoNode(properties: VideoProperties): VideoNode
{
    return $applyNodeReplacement(new VideoNode(properties));
}

export class VideoNode extends DecoratorNode<JSX.Element>
{
    static getType(): string
    {
        return 'video';
    }

    static clone(node: VideoNode): VideoNode
    {
        return new VideoNode(node.properties, node.__key);
    }

    static importJSON(serializedNode: SerializedVideoNode): VideoNode
    {
        const node = $createVideoNode(serializedNode.properties ?? {  src: '' });
        return node;
    }

    static importDOM(): DOMConversionMap
    {
        const convertIFrame = (el: HTMLElement) =>
        {
            const properties =
            {
                src: el.getAttribute('src') || '',
                // eslint-disable-next-line no-undefined
                title: el.getAttribute('title') || undefined,
                // eslint-disable-next-line no-undefined
                width: el.getAttribute('width') ? Number(el.getAttribute('width')) : undefined,
                // eslint-disable-next-line no-undefined
                height: el.getAttribute('height') ? Number(el.getAttribute('height')) : undefined,
                // eslint-disable-next-line no-undefined
            };
            return { node: $createVideoNode(properties) };
        };
        const video: any = () => ({ conversion: convertIFrame, priority: 1 });
        return { video };
    }

    exportDOM(): DOMExportOutput
    {
        const el = document.createElement('video');
        const props = this.properties ?? { src: '' };

        if (props.src) { el.setAttribute('src', props.src); }
        // if (props.title) { el.setAttribute('title', props.title as string); }
        if (typeof props.width === 'number' && props.width > 0) { el.setAttribute('width', String(props.width)); }
        if (typeof props.height === 'number' && props.height > 0) { el.setAttribute('height', String(props.height)); }

        return { element: el };
    }

    properties?: VideoProperties;

    constructor(properties?: VideoProperties, key?: NodeKey)
    {
        super(key);
        this.properties = properties;
    }

    createDOM(): HTMLElement
    {
        const span = document.createElement('span');
        span.className = 'resizable';
        return span;
    }

    updateDOM(): false
    {
        return false;
    }

    decorate()
    {
        try
        {
            return <Video nodeKey={this.getKey()} properties={this.properties} />;
        }
        catch (error) { /* empty */ }
        return <span>{this.properties?.src}</span>;
    }

    exportJSON(): SerializedVideoNode
    {
        return { type: 'video', version: 1, properties: this.properties };
    }

    setSize(width: number, height: number)
    {
        const writable = this.getWritable();
        writable.properties = writable.properties || { src: '' };
        writable.properties.width = width;
        writable.properties.height = height;
    }
}